import { render, staticRenderFns } from "./CAInfo.vue?vue&type=template&id=72f3f6f0&scoped=true"
import script from "./CAInfo.vue?vue&type=script&lang=js"
export * from "./CAInfo.vue?vue&type=script&lang=js"
import style0 from "./CAInfo.vue?vue&type=style&index=0&id=72f3f6f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3f6f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f3f6f0')) {
      api.createRecord('72f3f6f0', component.options)
    } else {
      api.reload('72f3f6f0', component.options)
    }
    module.hot.accept("./CAInfo.vue?vue&type=template&id=72f3f6f0&scoped=true", function () {
      api.rerender('72f3f6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/CAInfo.vue"
export default component.exports